import type { Role } from '@/domain/entities/role.entity'
import type { RoleDto } from './role.dto'

function codesFrom(dto: RoleDto): string[] {
  const list = dto.permission_codes ?? dto.permissions ?? []
  return list.map((p) => (typeof p === 'string' ? p : p.code))
}

export const roleMapper = {
  toRole(dto: RoleDto): Role {
    return {
      id: dto.id,
      name: dto.name,
      isSystem: Boolean(dto.is_system),
      permissionCodes: codesFrom(dto),
    }
  },
}
